import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../store/useAuthStore";
import { useUIStore } from "../store/useUIStore";

// Interfaces
import { AdminUser } from "../interfaces/AdminUser";
import { Participant } from "../interfaces/Participant";

// Firebase
import { firestore } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { genDoc } from "../utils/firebase";
export const useFetchUser = () => {
    const { authUser, fetchingAuth } = useAuthStore();
    const { loading, setLoading, yesterdayFallsCalendarCheck, setYesterdayFallsCalendarCheck } = useUIStore();

    const { data: userData, isLoading: isFetchingData } = useQuery(
        ["user", authUser?.uid],
        async () => {
            if (!authUser) return { currentAdmin: null, currentParticipant: null };

            if (authUser.displayName === "Participants") {
                const participantDoc = await getDoc(doc(firestore, "Participants", authUser.uid));
                return { currentAdmin: null, currentParticipant: genDoc<Participant>()(participantDoc) };
            } else {
                const adminDoc = await getDoc(doc(firestore, "Users", authUser.uid));
                return { currentAdmin: genDoc<AdminUser>()(adminDoc), currentParticipant: null };
            }
        },
        {
            enabled: !fetchingAuth && !!authUser,
            staleTime: Infinity,
        }
    );

    const isFetchingUser = fetchingAuth || (!!authUser && isFetchingData);

    return {
        currentAdmin: userData?.currentAdmin ?? null,
        currentParticipant: userData?.currentParticipant ?? null,
        fetchingUser: isFetchingUser,
        loading,
        setLoading,
        yesterdayFallsCalendarCheck,
        setYesterdayFallsCalendarCheck,
    };
};
